import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SearchConfig} from '@components/my-requests/my-requests.component';
import {debounceTime, Subject} from 'rxjs';
import {NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-search-panel',
  imports: [
    NgIf,
    NgForOf,
    FormsModule
  ],
  templateUrl: './search-panel.component.html',
  styleUrl: './search-panel.component.css'
})
export class SearchPanelComponent implements OnInit {

  @Input() searchFields: SearchConfig[] = [];

  @Output() searchParamChange = new EventEmitter<any>();

  isOpen: boolean = false;
  currentParams: any = {}
  private searchSubject = new Subject<any>();

  inputValues: { [key: string]: any } = {};

  constructor() {
    this.searchSubject.pipe(
      debounceTime(300)
    ).subscribe(params => {
      this.searchParamChange.emit(params);
    })
  }

  togglePanel() {
    this.isOpen = !this.isOpen;
  }

  resetFilters() {
    this.inputValues = {}
    this.currentParams = {}
    this.searchParamChange.emit({})
  }

  onParamsChange(key: string, value: string) {
    const currentValue = this.inputValues[key]

    if (currentValue) {
      this.currentParams[key] = currentValue.toLowerCase();
    } else {
      delete this.currentParams[key];
    }

    this.searchSubject.next(this.currentParams);
  }

  ngOnInit(): void {
    this.searchFields.filter(field => field.type === 'select').forEach(field => {
      this.inputValues[field.key] = ''
    })
  }

}
